/**
 * PAD → standalone Cover Page trigger
 * -----------------------------------
 * After a dirty PAD approve, standard orgs fire TriggerCoverPage so the Cover
 * Page stays in sync with the newly approved core sections.
 *
 * TOC and SLaM Report Builder omit the standalone Cover Page entirely
 * (replaceCARwithReportBuilder). Calling TriggerCoverPage for those patients would
 * write cpReport* / coverPageReport with no Documents Dashboard row to surface
 * the result — including a latent TOC leak that existed before this helper.
 *
 * Kept as a tiny pure wrapper so unit tests can lock the gate without mounting
 * the full PAD review page (which needs sectionDirty + many review-UI mocks).
 */

/**
 * @param {Object} opts
 * @param {boolean} opts.replaceCARwithReportBuilder - From useWorkflowConfig / resolveWorkflowConfig
 * @param {string} opts.clinicianId
 * @param {string} opts.patientId
 * @param {Function} opts.triggerCoverPage - Injected TriggerCoverPage (or a mock in tests)
 * @returns {boolean} true when TriggerCoverPage was invoked
 */
export function triggerPadCoverPageIfNeeded({
  replaceCARwithReportBuilder,
  clinicianId,
  patientId,
  triggerCoverPage,
}) {
  if (replaceCARwithReportBuilder) {
    return false;
  }
  triggerCoverPage({
    clinicianId,
    patientId,
    reportType: 'Cover Page - Regular',
  });
  return true;
}
